export default {
  FETCH_CUMULATIVE_WINNERS_HISTORY_REQUEST: 'FETCH_CUMULATIVE_WINNERS_HISTORY_REQUEST',
  FETCH_CUMULATIVE_WINNERS_HISTORY_SUCCESS: 'FETCH_CUMULATIVE_WINNERS_HISTORY_SUCCESS',
  FETCH_CUMULATIVE_WINNERS_HISTORY_FAILURE: 'FETCH_CUMULATIVE_WINNERS_HISTORY_FAILURE',

  DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_REQUEST: 'DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_REQUEST',
  DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_SUCCESS: 'DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_SUCCESS',
  DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_FAILURE: 'DOWNLOAD_CUMULATIVE_WINNERS_HISTORY_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/cumulative-winners/action-types.js